export default __webpack_public_path__ + "static/logo-11-999f5c0ea0a386d8577f65fd4f67ed01.jpeg";